"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledImageWrapper = exports.StyledImageInner = exports.StyledImage = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3;

var StyledImageWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: 200px;\n  position: relative;\n  text-align: center;\n  display: inline-block;\n  ", "\n\n  .eui-upload-button {\n    margin: 16px auto 0px auto;\n  }\n"])), _styledSystem.space);

exports.StyledImageWrapper = StyledImageWrapper;

var StyledImageInner = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 200px;\n  height: 200px;\n  border-radius: ", ";\n  background-color: ", ";\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), (0, _utils.getBorderRadius)('primary'), (0, _utils.getPalette)('base', 'c00'));

exports.StyledImageInner = StyledImageInner;

var StyledImage = _styledComponents["default"].img(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: 100%;\n  font-size: 12px;\n  line-height: 100%;\n"])));

exports.StyledImage = StyledImage;